module.exports = __webpack_public_path__ + "static/media/Accounts_Home.f3b28fef.mp4";